const LOG_SENSITIVE_FIELDS = ['patient_hashes'];

const MAX_LENGTH = 6;
const MAX_ITEMS = 5;
const SUFFIX = '...';

const hasSensitiveField = (data) => LOG_SENSITIVE_FIELDS.some((field) => data.includes(field));

const fixSingleQuotesIfNeeded = (data) => {
  const shouldFix = LOG_SENSITIVE_FIELDS.some((field) => data.includes(`'${field}'`));

  if (!shouldFix) {
    return data;
  }

  return data.replace(/'/g, '"').replace(/,\s*([\]}])/g, '$1');
};

const truncate = (value) =>
  typeof value === 'string' && value.length > MAX_LENGTH ? `${value.slice(0, MAX_LENGTH)}${SUFFIX}` : value;

const truncateField = (value) => {
  if (typeof value === 'string') {
    return truncate(value);
  }

  if (!Array.isArray(value)) {
    return value;
  }

  const items = value.slice(0, MAX_ITEMS).map(truncate);

  if (value.length > MAX_ITEMS) {
    items.push(SUFFIX);
  }

  return items;
};

const sanitize = (obj) => {
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) {
    return obj;
  }

  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [
      key,
      LOG_SENSITIVE_FIELDS.includes(key) ? truncateField(value) : sanitize(value),
    ])
  );
};

const parse = (data) => {
  try {
    return JSON.parse(data);
  } catch {
    try {
      return JSON.parse(fixSingleQuotesIfNeeded(data));
    } catch {
      return null;
    }
  }
};

export const formatLogAdditionalData = (additionalData) => {
  if (!additionalData || !hasSensitiveField(additionalData)) {
    return additionalData;
  }

  const parsed = parse(additionalData);

  if (!parsed) {
    return additionalData;
  }

  return JSON.stringify(sanitize(parsed));
};
